import { Canvas } from '@gush/candybar';
import Cannon from './modules/Cannon';
import Clear from './modules/Clear';
import Background from './modules/Background';

const canvas = new Canvas({
    canvas: document.getElementById('canvas'),
    container: document.getElementById('container'),
    // dpr: 1,
    hasPointer: true,
    pauseInBackground: true,
    entities: [new Clear(), new Background(), new Cannon()],
});
